import * as React from 'react';

function SvgArmstrongFeedback(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={64}
      height={64}
      {...props}
    >
      <style>
        {
          '.feedback_spotillustration_64x64_svg__st1{fill:none;stroke:#00dea4;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.feedback_spotillustration_64x64_svg__st55{fill:#131c27}.feedback_spotillustration_64x64_svg__st59,.feedback_spotillustration_64x64_svg__st60{fill:none;stroke:#131c27;stroke-miterlimit:10}.feedback_spotillustration_64x64_svg__st60{stroke-linecap:round}'
        }
      </style>
      <g id="feedback_spotillustration_64x64_svg__Layer_1">
        <path
          className="feedback_spotillustration_64x64_svg__st1"
          d="M35.79 29.52c3.57.18 5.81-.1 6.91-.22 2.75 2.3-1 8.01-1 8.01s5.61-1.34 6.13-7.19c.57-6.49-6.22-2.83-1.31-.93 3.61 1.39 17.13-1.61 16.46-13.29C62.24 2.93 45.51 1.41 38.74 1.6c-11.29.34-21.87 5.7-20.12 18.28.45 3.22 2.35 5.4 4.91 6.86M31.74 10.75h18.51M31.74 19.62h18.51M28.03 15.18h25.93"
        />
        <g>
          <path
            d="M19.33 38.85l-1.53.02c-1.51.02-2.75-1.14-2.78-2.59-.03-1.46 1.16-2.66 2.67-2.68l2.38-.04s11.52-3.15 9.7-13.7c-.96-1.95-14.21-4-19.15 4.56-4.26 7.38-7.59 20.16-3 23.55 3.11 2.29 12.39 3.14 14.64.06-1.29-4.57-2.93-9.18-2.93-9.18z"
            fill="#151c26"
          />
          <path
            className="feedback_spotillustration_64x64_svg__st59"
            d="M28.46 52.59v-5.18h8.02s2.75-28.24-11.14-28.24c-14.71 0-14.25 14.35-14.25 16.2v17.51"
          />
          <path
            className="feedback_spotillustration_64x64_svg__st55"
            d="M28.08 46.97h-2.9l3.26 2.15z"
          />
          <path
            className="feedback_spotillustration_64x64_svg__st60"
            d="M34.78 32.71s-.02-.94-.93-.9c-.76.04-.74.93-.74.93M28.44 32.71s-.02-.94-.93-.9c-.76.04-.74.93-.74.93"
          />
          <path
            className="feedback_spotillustration_64x64_svg__st59"
            d="M36.61 27.26s-5.41-2.06-5.47 2.28c-.04 2.57 1.22 4.58 1.96 5.86.49.85.1 1.93-.82 2.27l-1.89.71"
          />
          <path
            className="feedback_spotillustration_64x64_svg__st55"
            d="M31.57 41.46l-5.52-2.86s-1.06 2.67 1.37 3.89c2.59 1.29 4.15-1.03 4.15-1.03z"
          />
          <path
            d="M.1 62.89c1.77-4.34 7-11.87 21.83-11.42 20.27.61 21.41 11.42 21.41 11.42s-38.29-.05-43.24 0z"
            fill="#c6f16d"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgArmstrongFeedback;
